export class Version {

    public versao = {
        atual: '1.1.1',
        mostrar: false,
        title: 'Melhorias Gerais',
        itens: [
            "Dashboard - Adicionado Próximos remates",
            "Suporte - Ajustes de layout.",
        ],
        date: '21/10/2025',
        historico: [
            {
                atual: '1.1.0',
                mostrar: true,
                title: 'Suporte - Acompanhamento de Remates',
                itens: [
                    "Suporte - listagem de remates com controles de suporte e contagem de horas.",
                ],
                date: '06/06/2025',
            },
            {
                atual: '1.0.9',
                mostrar: false,
                title: 'Melhorias na Agenda de Remates',
                itens: [
                    "Agenda, adicionado responsável do suporte pelo remate.",
                    "Agenda, adicionado marcação para suporte presencial (viajar).",
                ],
                date: '28/05/2025'
            },
            {
                atual: '1.0.8',
                mostrar: false,
                title: 'Marketing / CS',
                itens: [
                    "Central de parceiros.",
                    "Melhorias visuais em geral.",
                ],
                date: '28/05/2025'
            },
            {
                atual: '1.0.7',
                mostrar: false,
                title: 'Financeiro',
                itens: [
                    "Dashboard mensal.",
                    "Lista de Remates."
                ],
                date: '05/05/2025'
            },
            {
                atual: '1.0.6',
                mostrar: true,
                title: 'Faturamento',
                itens: [
                    "Adicionado observação no faturamento."
                ],
                date: '02/04/2025',
            },
            {
                atual: '1.0.5',
                mostrar: true,
                title: 'Monitor Rfy!',
                itens: [
                    "Monitor Rematefy para acompanhar remates ao vivo!",
                    "Ajustes no tema claro.",
                    "Ajustes no tema escuro."
                ],
                date: '02/04/2025',
            },
            {
                atual: '1.0.4',
                mostrar: true,
                title: 'Correções',
                itens: [
                    "Corrigido bug ao clicar 'Enter' na tela de Login",
                    "Alteração de nome 'Leiloeiras' para 'Escritórios'",
                    "Filtrar automáticamente escritórios ao clicar 'Enter' ou mudar Selects",
                    "Ajuste ao vincular Escritórios em Sindicatos",
                ],
                date: '22/08/2024',
            },
            {
                atual: '1.0.3',
                mostrar: true,
                title: 'Dashboard & Cadastro de Primeiro Usuário',
                itens: [
                    "Ao cadastrar uma nova leiloeira, já cadastre o <b>Usuário Rematefy<b>!",
                    "Ajustes visuais na <b>Navegação Lateral</b>",
                    "Ajustes visuais na <b>Navegação Superior</b>",
                    "Dashboard finalizada!",
                ],
                date: '31/07/2024',
            },
            {
                atual: '1.0.2',
                mostrar: true,
                title: 'Melhorias de Navegação e Dashboard',
                itens: [
                    "Para <b>Layout Vertical</b>, nas <b>Configuração</b>, defina navegação lateral como: <b>ESTENDIDA</b> ou <b>REDUZIDA</b>.",
                    "Para <b>Layout Horizontal</b>, nas <b>Configuração</b>, defina navegação superior como: <b>ESCONDIDA</b> ou <b>VISÍVEL</b>.",
                    "Dashboard trazendo últimos remates e resumo de seus resultados.",
                    "Adicionado filtros para pesquisa de Leiloeiras.",
                    "Adicionado página de histórico de versões.",
                ],
                date: '29/07/2024',
            },
            {
                atual: '1.0.1',
                mostrar: true,
                title: 'Melhorias No Cadastro de Leiloeira',
                itens: [
                    "Personalização de Card para Agenda",
                    "Observações Sobre as Leiloeiras",
                    "Ajuste nas logos dos Cadastros",
                    "Mapa Geográfico de Leiloeiras",
                    "Visual Inicial de Dash (Sem Dados, no momento)"
                ],
                date: '24/07/2024',
            },
            {
                atual: '1.0.0',
                mostrar: true,
                title: 'Start!',
                itens: [
                    "Configurações Iniciais do Gestor",
                    "Cadastro de Sindicatos",
                    "Cadastro de Leiloerias",
                    "Agenda de Remates",
                ],
                date: '20/06/2024',
            }
        ]
    };

}
